import React from 'react';
import { RegionName } from '../../../../types/region.mjs';
import UncoloredLogoIcon from './UncoloredLogoIcon.mjs';
import { DarkWestchesterLogo, DarkNewYorkLogo, DarkNewJerseyLogo, DarkLongIslandLogo, DarkHudsonValleyLogo, DarkConnecticutLogo, DarkBrooklynLogo, DarkTheBronxLogo, DarkDefaultLogo } from './dark.mjs';
import { LightWestchesterLogo, LightNewYorkLogo, LightNewJerseyLogo, LightLongIslandLogo, LightHudsonValleyLogo, LightConnecticutLogo, LightBrooklynLogo, LightTheBronxLogo, LightDefaultLogo } from './light.mjs';
import styled, { useTheme } from 'styled-components';

const StyledLogoWrapper = styled.div `
  display: inline-block;
  width: 111px;
  height: 37px;
`;
var LogoVariant;
(function (LogoVariant) {
    LogoVariant["REGULAR"] = "regular";
    LogoVariant["UNCOLORED"] = "uncolored";
})(LogoVariant || (LogoVariant = {}));
const lightLogoComponents = {
    [RegionName.DEFAULT]: LightDefaultLogo,
    [RegionName.THE_BRONX]: LightTheBronxLogo,
    [RegionName.BROOKLYN]: LightBrooklynLogo,
    [RegionName.CONNECTICUT]: LightConnecticutLogo,
    [RegionName.HUDSON_VALLEY]: LightHudsonValleyLogo,
    [RegionName.LONG_ISLAND]: LightLongIslandLogo,
    [RegionName.NEW_JERSEY]: LightNewJerseyLogo,
    [RegionName.NEW_YORK]: LightNewYorkLogo,
    [RegionName.WESTCHESTER]: LightWestchesterLogo
};
const darkLogoComponents = {
    [RegionName.DEFAULT]: DarkDefaultLogo,
    [RegionName.THE_BRONX]: DarkTheBronxLogo,
    [RegionName.BROOKLYN]: DarkBrooklynLogo,
    [RegionName.CONNECTICUT]: DarkConnecticutLogo,
    [RegionName.HUDSON_VALLEY]: DarkHudsonValleyLogo,
    [RegionName.LONG_ISLAND]: DarkLongIslandLogo,
    [RegionName.NEW_JERSEY]: DarkNewJerseyLogo,
    [RegionName.NEW_YORK]: DarkNewYorkLogo,
    [RegionName.WESTCHESTER]: DarkWestchesterLogo
};
const Logo = ({ variant = LogoVariant.REGULAR, region = RegionName.DEFAULT }) => {
    const theme = useTheme();
    if (variant !== LogoVariant.REGULAR) {
        return React.createElement(UncoloredLogoIcon, null);
    }
    const LogoComponent = theme.name === 'light' ? lightLogoComponents[region] : darkLogoComponents[region];
    return (React.createElement(StyledLogoWrapper, null,
        React.createElement(LogoComponent, null)));
};

export { LogoVariant, StyledLogoWrapper, Logo as default };
//# sourceMappingURL=Logo.mjs.map
